import { useEffect, useState } from 'react';

export const useResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const onResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return {
    isMobile: width <= 991,
    isMdDesktop: width > 991 && width <= 1200,
    isLgDesktop: width > 1200 && width <= 1800,
    isLgScreen: width > 1800,
  };
};
